// src/modules/Chat/CommentSection.jsx
import React, { useEffect, useState } from "react";
import {  subscribeComments } from "../firebaseAPI";
import MediaUploadButton from "../Button/MediaUploadButton";
import "./CommentSection.css";
export default function CommentSection({ nodeId, userId }) {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [mediaUrl, setMediaUrl] = useState(null);
  const [sendRemainingTime, setSendRemainingTime] = useState(0);
  const sendInterval = 10000;

  // コメント購読
  useEffect(() => {
    if (!nodeId) return;
    const unsubscribe = subscribeComments(nodeId, (data) => setComments(data));
    return () => unsubscribe();
  }, [nodeId]);

  // コメント送信
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim() && !mediaUrl) return;

    try {
      /*
      const commentId = await addComment({
        nodeId,
        userId,
        content: newComment,
        mediaUrl,
      });
      console.log("Comment added, Comment ID:", commentId);
      addComment,を使う場合最初に追加
      */
      setNewComment("");
      setMediaUrl(null);

      // 🔹 送信後カウント開始
      setSendRemainingTime(sendInterval);
      const timer = setInterval(() => {
        setSendRemainingTime((prev) => {
          if (prev <= 1000) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1000;
        });
      }, 1000);
    } catch (err) {
      console.error("Failed to send comment:", err);
    }
  };

  const handleUploadComplete = (url) => setMediaUrl(url);

  return (
    <div className="comment-section">
      {/* コメントリスト */}
<ul className="comments-list">
  {comments.map((c, index) => {
    const isMine = c.userId === userId;
    const number = index + 1; // ← 通し番号

    return (
     <li
        key={c.id}
        className={`comment-item ${isMine ? "mine" : "other"}`}
        id={`comment-${number}`} // ← ページ内リンク用 ID
      >
        <div className={`comment-bubble ${isMine ? "mine" : "other"}`}>
          <div className="comment-meta">

            {/* ▼▼ ここがクリックできる番号 ▼▼ */}
            <span
              className="comment-number"
              style={{ cursor: "pointer", marginRight: "6px", fontWeight: "bold" }}
              onClick={() => {
                // 入力欄へ追記
                setNewComment((prev) => prev + ` #${number} `);

                // コメント入力欄へフォーカス
                //document.getElementById("comment-input")?.focus();

                // コメント位置へスクロール
                
                document.getElementById(`comment-${number}`)?.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }}
            >
              #{number}
            </span>
            {/* ▲▲ クリックできる番号 ▲▲ */}
            
            
            
            <span>　　ID:{c.userId?.slice(0, 8) || "匿名"}</span>
            <span>　　投稿日：{c.createdAt?.toDate?.()?.toLocaleString() || ""}</span>
          </div>

          {c.content && <div>{c.content}</div>}
          {c.mediaUrl && (
            <div style={{ marginTop: "4px" }}>
              <img
                src={c.mediaUrl}
                alt="添付画像"
                style={{ maxWidth: "200px", borderRadius: "8px" }}
              />
            </div>
          )}
        </div>
      </li>
    );
  })}
</ul>

      {/* 入力欄 */}
      {mediaUrl && (
        <div
          style={{
            width: "100%",
            backgroundColor: "rgba(0,0,0,0.2)",
            margin: "8px 0",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "8px",
          }}
        >
          <img
            src={mediaUrl}
            alt="アップロードプレビュー"
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "8px",
              objectFit: "cover",
            }}
          />
          <div style={{ color: "black", fontSize: "12px", marginTop: "4px" }}>
            アップロード画像
          </div>
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="comment-form"
        style={{ display: "flex", alignItems: "center" }}
      >
        {nodeId !== "homePage" && (
          <MediaUploadButton
            accept="image/*"
            label="＋"
            onUploadComplete={handleUploadComplete}
            remainingTime={sendRemainingTime}
          />
        )}
        <textarea
        id="comment-input"
          placeholder="コメントを入力"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          maxLength={500}
          style={{
            flex: 1,
            marginLeft: "8px",
            minHeight: "10px", // ← 任意： 高さ
            resize: "vertical", // ← 任意： サイズ変更を許可
            padding: "8px", // ← 任意： 見た目調整
          }}
        />

        <button
          type="submit"
          style={{ marginLeft: "8px" }}
          disabled={sendRemainingTime > 0}
        >
          送信
        </button>
      </form>
    </div>
  );
}
